<template>
  <van-config-provider style="height:100%">
    <van-nav-bar :title="$route.meta.title"  left-arrow v-if="['index','login'].indexOf($route.name)==-1"  @click-left="onClickLeft" />
    <router-view />
  </van-config-provider>
  </template>
  <script>
  import { provide } from "vue";
  import { useRoute, useRouter } from "vue-router";
  export default {
    name: "App",
    setup(props) {
      // 路由
      provide("$router", useRouter());
      provide("$route", useRoute());
      provide('_lodash',require('lodash'))
      const router=useRouter()
      const route=useRoute()
      const onClickLeft = () => {
        router.back(-1);
      };
       window.addEventListener('hashchange', () => {
        let currentPath = window.location.hash.slice(1)
        if (route.path !== currentPath) {
          router.push(currentPath)
        }
      }, false)

      return {
        onClickLeft,
      };
    },
  };
  </script>
  <style lang="scss">
  @import "./styles/base.scss";
  html,
  body,
  #app {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background-color: #f5f5f5;
    -webkit-overflow-scrolling: touch;
  }
  </style>
